var React = require('react');

function ChevronRightInline (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M0.740234 2.44686L5.04431 6.75006L0.740234 11.0533L2.58907 12.9021L8.74023 6.75006L2.58907 0.598026L0.740234 2.44686Z","fill":"#16384E"}));
}

ChevronRightInline.defaultProps = {"width":"9","height":"13","viewBox":"0 0 9 13","fill":"none"};

module.exports = ChevronRightInline;

ChevronRightInline.default = ChevronRightInline;
